var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"head-box"},[_c('headPage',{attrs:{"active":_vm.headActive}})],1),_c('div',{staticClass:"main"},[_c('div',{staticClass:"content-view"},[_c('router-view',{on:{"setActive":_vm.getActive}})],1)]),_c('div',{staticClass:"foot-box"},[_c('footPage')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }